export enum FnfMessage {
    FINAL_AND_BLOCKED = "FINAL_AND_BLOCKED",
    UNFINAL_AND_UNBLOCKED = "UNFINAL_AND_UNBLOCKED",
}